import api from "./api";
const endpoint = "/WebsiteRestController";
export const OffreService = {
  async getAllOfMyDemands(filtre) {
    try {
      const result = await api.get(endpoint + "/mes_demande_list", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getAllOffre(filtre) {
    try {
      const result = await api.get(endpoint + "/offre_emploi_list", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneById(id) {
    try {
      const result = await api.get(endpoint + "/offre_detail", {
        params: { id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async postuler(id_offre) {
    try {
      const result = await api.post(endpoint + "/offre_emploi_list", id_offre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getExperiencesList(filtre) {
    try {
      const result = await api.post(endpoint + "/recuperer_experience_et_reponse", filtre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
